import React from 'react'
import PropTypes from 'prop-types'

// Nút cộng bo vuông vuông, nút cộng thì sắc nhọn, không mềm mại
const PlusIcon2 = ({ size = '25', color = 'white', bgColor = 'black' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none">
      <rect x="0.210571" y="0.934082" width="24" height="24" rx="3.47368" fill={bgColor} />
      <path
        d="M13.204 11.9406V8.64844H11.217V11.9406H7.9248V13.9277H11.217V17.2199H13.204V13.9277H16.4962V11.9406H13.204Z"
        fill={color}
      />
    </svg>
  )
}

export default React.memo(PlusIcon2)
PlusIcon2.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  bgColor: PropTypes.string,
}
